import React from 'react';
import {
  Rocket, UserPlus, CalendarPlus, Clock, FileText, Receipt,
  Download, Cloud, BookOpen, Shield, Settings, Lock, ChevronRight,
} from 'lucide-react';
import type { HelpArticle } from '../../data/helpArticles';
import { CATEGORY_LABELS } from '../../data/helpArticles';

const ICON_MAP: Record<string, React.FC<{ size?: number }>> = {
  Rocket, UserPlus, CalendarPlus, Clock, FileText, Receipt,
  Download, Cloud, BookOpen, Shield, Settings, Lock,
};

interface Props {
  article: HelpArticle;
  compact?: boolean;
  onClick: (article: HelpArticle) => void;
}

export default function HelpArticleCard({ article, compact, onClick }: Props) {
  const IconComp = ICON_MAP[article.icon] || BookOpen;

  if (compact) {
    return (
      <button
        className="help-card-compact"
        onClick={() => onClick(article)}
      >
        <div className="help-card-compact-icon">
          <IconComp size={16} />
        </div>
        <div className="help-card-compact-text">
          <span className="help-card-compact-title">{article.shortTitle}</span>
          <span className="help-card-compact-desc">{article.description}</span>
        </div>
        <ChevronRight size={14} className="help-card-compact-chevron" />
      </button>
    );
  }

  return (
    <button
      className="help-card"
      onClick={() => onClick(article)}
    >
      <div className="help-card-icon">
        <IconComp size={22} />
      </div>
      <div className="help-card-body">
        <h3 className="help-card-title">{article.title}</h3>
        <p className="help-card-desc">{article.description}</p>
        <div className="help-card-meta">
          <span className="help-card-category">{CATEGORY_LABELS[article.category]}</span>
          {article.estimatedMinutes && (
            <span className="help-card-time">
              <Clock size={12} />
              {article.estimatedMinutes} Min.
            </span>
          )}
        </div>
      </div>
    </button>
  );
}
